var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showPagePath)?_c('div',{class:['page-path', _vm.variant]},_vm._l((_vm.navigation),function(n,key){return _c('div',{key:key,staticClass:"route-element"},[(n.route)?_c('router-link',{attrs:{"to":n.route}},[_vm._v(_vm._s(n.title))]):_c('span',[_vm._v(_vm._s(n.title))])],1)})):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fe12db3","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/dndg/components/page-path.vue
// module id = 91
// module chunks = 0